<template>
  <table>
    <thead>
      <th>Attribute</th>
      <th>Value</th>
    </thead>
    <tbody>
      <tr v-for="attribute in attributes" :key="attribute.name">
        <td>{{ attribute.name }}</td>
        <td>
          <DataCell :type="attribute.type" :value="data[attribute.name]" />
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import DataCell from '@/components/DataCell.vue'

export default {
  name: 'DataList',
  props: {
    attributes: Array,
    data: Object
  },
  components: {
    DataCell
  }
}
</script>

<style scoped>
table {
  width: 100%;
  border-spacing: 0;
}
thead {
  text-align: left;
}
</style>
